module.exports = __webpack_public_path__ + "img/xyz.beb27146.png";